import { render, staticRenderFns } from "./MigrationsHistory.vue?vue&type=template&id=5bc6e4e8"
import script from "./MigrationsHistory.vue?vue&type=script&lang=js"
export * from "./MigrationsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports